import { Group } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { Controller, type Control } from "react-hook-form";
import type { Contract } from "../../../../DeliveryOverview.types";
import { NumberCell } from "../Cells/NumberCell";
import { TextCell } from "../Cells/TextCell";
import type { PaymentRow } from "../PaymentsTab";

export function getDiscountColumn(
  control: Control<Contract>
): MRT_ColumnDef<PaymentRow> {
  return {
    header: "Rabatt/Bonus (Brutto)",
    Cell: ({ row }) => (
      <Group align="baseline" grow justify="space-between">
        <Controller
          control={control}
          name={`payments.${row.original.formIndex}.discount_payments`}
          render={({ field, fieldState }) => (
            <NumberCell
              error={fieldState.error?.message}
              min={0}
              unit="€"
              updateValue={field.onChange}
              value={field.value ?? null}
            />
          )}
        />
        <Controller
          control={control}
          name={`payments.${row.original.formIndex}.discount_description`}
          render={({ field, fieldState }) => (
            <TextCell
              error={fieldState.error?.message}
              placeholder="Begründung eingeben"
              updateValue={field.onChange}
              value={field.value ?? undefined}
            />
          )}
        />
      </Group>
    )
  };
}
